import { useState } from "react";
import type { LineaProrrateo } from "@/features/prorrateo/types";
import { LineaRowView } from "./LineaRowView";
import { LineaRowEdit } from "./LineaRowEdit";

interface Props {
  indicadorFijo?: boolean;
  linea: LineaProrrateo;
  disabled: boolean;
  solicitudId: string;
}

/**
 * Fila del prorrateo MANUAL (Contrapago) · alterna lectura/edición con el lápiz.
 * Los prorrateos por conceptos (FB60/CA/OC) usan `SubLineaRow` dentro de `ConceptosTable`.
 */
export function LineaRow({ linea, disabled, solicitudId, indicadorFijo = false }: Props) {
  const [editing, setEditing] = useState(false);

  return editing ? (
    <LineaRowEdit
      indicadorFijo={indicadorFijo}
      linea={linea}
      solicitudId={solicitudId}
      onClose={() => setEditing(false)}
    />
  ) : (
    <LineaRowView
      linea={linea}
      disabled={disabled}
      solicitudId={solicitudId}
      onEdit={() => setEditing(true)}
    />
  );
}
